<template>
  <div>
    <label for="notes" class="label" >
      <slot name="label" />
    </label>
    <div class="mt-1">
      <slot name="input" :class="{'input-error': fails}">
      </slot>
    </div>
    <div v-if="fails" class="label-error mt-2">
      <span v-html="error" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({field: String, errors: Object});
const errors = computed(() => props.errors ?? {});
const fails = computed(() => errors.value[props.field]);
const error = computed(() => errors.value[props.field][0]);
</script>

<style scoped>
.label
{
  @apply block;
  @apply text-sm;
  @apply font-medium;
  @apply text-gray-700;
};

.label-error
{
  @apply text-sm;
  @apply text-red-600;
};
</style>
